import { ReactNode } from 'react';

type DescriptionProps = {
  children: ReactNode;
};

export const Description = ({ children }: DescriptionProps) => <p>{children}</p>;
